import React, { type JSX } from 'react';
import { Box, ToggleButtonGroup } from '@mui/material';
import { ErrorMessageText } from '../../../input/common';
import { ToggleButton } from './ToggleButton';

type LegacyRadioGroupingValue = { value: ToggleValue };
type ToggleValue = string | number;

type LegacyRadioGroupingProps = {
  options: { label: string; value: ToggleValue }[];
  value: LegacyRadioGroupingValue;
  onChange: (value: LegacyRadioGroupingValue) => void;
  error?: string;
  disabled?: boolean;
};

export const LegacyRadioGrouping = ({
  options,
  value,
  onChange,
  error,
  disabled,
}: LegacyRadioGroupingProps) => {
  const handleChange = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    nextValue: ToggleValue
  ) => {
    onChange?.({ ...value, value: nextValue });
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          minWidth: 0,
          overflowX: 'auto',
          overflowY: 'hidden',
        }}
      >
        <ToggleButtonGroup
          sx={{ flexWrap: 'nowrap' }}
          onChange={handleChange}
          value={value.value}
          exclusive
          disabled={disabled}
        >
          {options.map((option) => {
            return (
              <ToggleButton key={option.value} value={option.value}>
                {option.label}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Box>

      <ErrorMessageText>{error}</ErrorMessageText>
    </>
  );
};

type LegacyRadioGroupingContainerProps = {
  labelEl: JSX.Element | null;
} & LegacyRadioGroupingProps;

export const LegacyRadioGroupingContainer = (
  props: LegacyRadioGroupingContainerProps
) => {
  return (
    <React.Fragment>
      {props.labelEl}

      <LegacyRadioGrouping {...props} />
    </React.Fragment>
  );
};
